module.exports = __webpack_public_path__ + "static/EU4BLogoEn-84095b728f54416bd478f97610c6af5e.png";